import * as React from "react";

import primaryColour from "../../constants";

function SvgDriverlogoff(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3314 6.46732L15.7144 11.0843C15.5141 11.5855 15.2136 12.0433 14.8284 12.4285C14.4432 12.8137 13.9853 13.1143 13.4842 13.3145L11.5948 15.204C11.7297 15.2 11.8648 15.1987 12 15.2001C13.3944 15.1912 14.7758 15.4677 16.0594 16.0125C17.343 16.5573 18.5016 17.3589 19.464 18.3681C19.5085 18.4127 19.5523 18.4581 19.5957 18.5044C17.7617 20.6441 15.0392 21.9999 12 21.9999C9.23107 21.9999 6.72498 20.8745 4.91418 19.0562L19.0563 4.91406C19.5312 5.38696 19.9588 5.90728 20.3314 6.46732ZM14.2222 6.2742C14.3505 6.35991 14.4733 6.45267 14.59 6.55188L8.95177 12.1902C8.85255 12.0734 8.7598 11.9506 8.67408 11.8224C8.23456 11.1646 7.99996 10.3912 7.99996 9.60007C7.99996 8.53921 8.42139 7.52179 9.17154 6.77165C9.92168 6.0215 10.9391 5.60008 12 5.60008C12.7911 5.60008 13.5644 5.83467 14.2222 6.2742Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgDriverlogoff;
